import _initializerDefineProperty from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _createClass from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;
import { wrapperGet, wrapperPost } from '@/utils/http';
import { setRequestHeaderDecorator } from 'decor-core';
import { getSessionStorageKey } from '@/utils/utils';
import { setLoadingDecorator } from '@/api/common';
var setRequestConfig = {
  actChannel: getSessionStorageKey('activityKey') || null
};
export default new (_dec = setRequestHeaderDecorator(setRequestConfig), _dec2 = setRequestHeaderDecorator(setRequestConfig), (_class = /*#__PURE__*/_createClass(function UserApi() {
  _classCallCheck(this, UserApi);
  /*
   * 第三方支付平台
   * */
  _defineProperty(this, "thirdViewByPlatform", wrapperPost('/api/opuser/thirdViewByPlatform'));
  /**
   * 转售身份验证发送验证短信-单个转售
   */
  _defineProperty(this, "sendSmsCode", wrapperPost('/api/client-ubq-app/auctionMarket/sendBiddingSmsCode'));
  /**
   * 转售身份验证发送验证短信-批量转售
   */
  _defineProperty(this, "sendSmsCodeBatch", wrapperPost('/api/client-ubq-app/message/sms/send'));
  /*
   * 查询是否开通富友钱包
   * */
  _defineProperty(this, "getFuYouWallet", wrapperGet('/api/opuser/getFuYouWallet'));
  /*
   * 用户手动同步富友钱包
   * */
  _defineProperty(this, "refreshesWallet", wrapperGet('/api/opuser/refreshesWallet'));
  // 当代青年活动登录
  _initializerDefineProperty(this, "activeLogin", _descriptor, this);
  // 当代青年活动注册
  _initializerDefineProperty(this, "activeRegister", _descriptor2, this);
  /*
   * 通过短信(邮箱)验证码登录
   * */
  _defineProperty(this, "loginByCode", wrapperPost('/api/opuser/loginCode'));
  /*
   * 校验交易密码
   * */
  _defineProperty(this, "getTradePasswordStatus", wrapperGet('/api/opuser/tradePasswordStatus'));
  /*
   * 设置交易密码
   * */
  _defineProperty(this, "setTradePassword", wrapperPost('/api/opuser/setTradePassword'));
  /*
   * 登出
   * */
  _defineProperty(this, "logout", wrapperGet('/api/opuser/logout'));
  /*
   * 获取当前用户实名信息
   * */
  _defineProperty(this, "getRealNameInfo", wrapperGet('/api/opuser/realNameAuth'));
  /*
   * 获取当前用户信息
   * */
  _defineProperty(this, "getUserInfo", wrapperGet('/api/opuser/checkToken'));
  /*
   * 修改密码
   * */
  _defineProperty(this, "resetValidateCode", wrapperPost('/api/opuser/validateCode'));
  /*
   * 忘记密码 设置密码并登录
   * */
  _defineProperty(this, "newPwdLogin", wrapperPost('/api/opuser/resetPassByCode'));
  /*
   * 注册
   * */
  _defineProperty(this, "register", wrapperPost('/api/opuser/signUpOrLogin'));
  /*
   * 登录
   * */
  _defineProperty(this, "login", wrapperPost('/api/opuser/loginPassword'));
  /*
   * 获取手机验证码
   * */
  _defineProperty(this, "getVerifyCode", wrapperGet('/api/opuser/getCodeNoAuth'));
  /*
   * 获取修改密码手机验证码
   * */
  _defineProperty(this, "getAppVerifyCode", wrapperGet('/api/opclearing/account/getCode'));
  /*
   * 提交海星授权码
   * */
  _defineProperty(this, "userSubmitCode", wrapperPost('/api/opuser/user/submitCode'));
  /*
   * 用户钱包查询列表接口
   * */
  _defineProperty(this, "getUserWalletList", wrapperGet("/api/client-ubq-app/user/walletList"));
  /*
   * 修改用户相关动态配置
   * */
  _defineProperty(this, "modifyConfigUser", wrapperPost('/api/client-ubq-app/config/user'));
  /*
   * 获取用户相关的动态配置处理接口
   * */
  _defineProperty(this, "getConfigUser", wrapperGet('/api/client-ubq-app/config/user'));
  /*
   * 用户等级详情
   * */
  _initializerDefineProperty(this, "getUserLevelDetail", _descriptor3, this);
  /*
   * 用户近30天交易金额记录
   * */
  _defineProperty(this, "getTradeAmtLatest", wrapperGet('/api/client-ubq-app/user/tradeAmt/latest'));
  /*
   * 用户近30天资产估值记录
   * */
  _defineProperty(this, "getAssetValLatest", wrapperGet('/api/client-ubq-app/user/assetVal/latest'));
  /*
   * 获取用户私钥
   * */
  _defineProperty(this, "getUserPrivateKey", wrapperGet('/api/client-ubq-app/user/getUserPrivateKey'));
  /*
   * 查询绑定的第三方账号
   * */
  _defineProperty(this, "getThirdAccount", wrapperGet('/api/opuser/thirdAccount'));
  /*
   * 获取用户余额
   * */
  _defineProperty(this, "userWallet", function (currencyKind) {
    return wrapperGet("/api/opuser/userWallet/".concat(currencyKind));
  });
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "activeLogin", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost("/api/opuser/loginPassword");
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "activeRegister", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost("/api/opuser/signUpOrLogin");
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "getUserLevelDetail", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/user/level/detail');
  }
})), _class))();